// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/index.css
// module id = 353
// module chunks = 0